import {
  doc,
  setDoc,
  collection,
  query,
  where,
  getDocs,
  orderBy,
  limit
} from "firebase/firestore";
import { db } from "../../firebase";
import Cookies from "js-cookie";
import { Save_ledger_books } from "../ledger_accounts_root/save_ledger_books"
import { Randomcode } from "../../components_root/rendom_code";
export const Save_voucher_ledger = async (data) => {
  const {
    voucher,
    description,
    voucher_type,
    voucherid,
    voucherprintid,
    vouchernumber,
    totalamount,
    from_accountguid,
    to_accountguid
  } = data || {};

  // BASIC VALIDATION
  if (!voucher?.trim()) return { success: false, error: "Missing voucher." };
  if (!voucherid?.trim()) return { success: false, error: "Missing voucherid." };
  if (!voucherprintid?.trim()) return { success: false, error: "Missing voucherprintid." };
  if (!voucher_type?.trim()) return { success: false, error: "Missing save voucher_type" };
  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");
  const select_company_uid = Cookies.get("select_company_uid");

  if (!sessiontoken) return { success: false, error: "Session expired. Please relogin." };
  if (!guid) return { success: false, error: "Login expired. Please relogin." };
  if (!select_company_uid) return { success: false, error: "Contact service provider." };
  const servicetablename = "accountingfinancedb";
  try {
    // AUTH CHECK (user must be authorized for voucherid)
    const managerCollection = collection(
      db,
      servicetablename,
      select_company_uid,
      "ledger_accounts_manager"
    );
    const authQuery = query(
      managerCollection,
      where("accountguid", "==", guid),
      where("status", "==", true),
      where("voucherid", "==", voucherid)
    );
    const authSnap = await getDocs(authQuery);
    if (authSnap.empty) {
      return { success: false, error: "You are not authorized." };
    }
    //   const voucheraccountguid = from_accountguid;
    //   // MASTER ACCOUNT CHECK
    //   const masterQuery = query(
    //     managerCollection,
    //     where("account_type", "==", "master"),
    //     where("status", "==", true),
    //     where("ledger_account", "==", true),
    //     where("voucherid", "==", voucherid)
    //   );

    //   const masterSnap = await getDocs(masterQuery);

    //   if (masterSnap.empty) {
    //     voucheraccountguid = from_accountguid;
    //     //return { success: false, error: "Master account not authorized." };
    //   } else {

    //     const masterData = masterSnap.docs[0]?.data();
    //     voucheraccountguid = masterData?.accountguid;

    //     if (!voucheraccountguid) {
    //       return { success: false, error: "Invalid master account configuration." };
    //     }
    // }
    // SAVE AREA
    const tablename = "voucher_print";
    const voucherprintCollection = collection(
      db,
      servicetablename,
      select_company_uid,
      tablename
    );

    // INDEXNUMBER + TOKENS 
    let tokennumber = 1;
    const lastIndexQuery = query(
      voucherprintCollection,
      orderBy("date_time", "desc"),
      limit(1)
    );
    const lastIndexSnap = await getDocs(lastIndexQuery);
    if (!lastIndexSnap.empty) {
      const lastDoc = lastIndexSnap.docs[0].data();

      const lastDocDate = lastDoc?.date_time?.toDate?.();
      const lastToken = Number(lastDoc.tokennumber || 0);

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      let lastDateOnly = null;
      if (lastDocDate instanceof Date) {
        lastDateOnly = new Date(lastDocDate);
        lastDateOnly.setHours(0, 0, 0, 0);
      }

      if (lastDateOnly && lastDateOnly.getTime() === today.getTime()) {
        tokennumber = lastToken + 1;
      } else {
        tokennumber = 1;
      }
    }

    // SAVE TO CASH BOOK
    const result = await Save_ledger_books({
      accountguid_authority: guid,
      accountguid: from_accountguid,
      particulars: description,
      tokennumber,
      voucherprintid,
      voucherid: vouchernumber,
      voucher_type,
      credit: 0,
      debit: totalamount,
      date_time: new Date(),
    });

    if (!result?.success) {
      return { success: false, error: "Insufficient balance. Debit not allowed." };
    }

    // FINAL SAVE IN voucher_print
    const parentDocRef = doc(
      db,
      servicetablename,
      select_company_uid,
      tablename,
      voucherprintid
    );
    const slug = Randomcode(15).toLowerCase();
    const savequery = {
      ...data,
      tokennumber,
      companyuid: select_company_uid,
      guid,
      slug,
      receiptstatus: false,
      accountguid_authority: guid,
      sessiontoken,
      date_time: new Date(),
      date_time_update: new Date()
    };

    await setDoc(parentDocRef, savequery);
    // SAVE IN LEDGER
    await Save_ledger_books({
      accountguid_authority: guid,
      accountguid: to_accountguid,
      particulars: description,
      voucherprintid,
      tokennumber,
      voucherid:vouchernumber,
      voucher_type,
      credit: totalamount,
      debit: 0
    });

    return { success: true, message: "Voucher saved successfully." };
  } catch (err) {
    console.error("Error saving voucher:", err);
    return { success: false, error: err?.message || "Unknown error" };
  }
};
